// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
/**
 * Class to use for animation sources. Base class - not supposed to be used directly.
 */
class Source {
 /**
  */
 getSourceData() {}

 /**
  * Sets the current time and moves the {@link AnimationClipInstance} forward.
  * @param {number} globalTime
  * @returns {boolean} True to stay active - false to not stay active.
  */
 setTime(globalTime) {
   return true;
 }

 /**
  * Set the clip start time
  * @param {number} newStartTime the new start time for the source
  */
 setStartTime(newStartTime) {}

 /**
  * Sets start time. If set to current time, clip is reset
  * @param {number} globalStartTime
  */
 resetClips(globalStartTime) {}

 /**
  * @param {number} shiftTime
  */
 shiftClipTime(shiftTime) {}

 /**
  * Sets the time scale for the source.
  * @param {number} timeScale
  */
 setTimeScale(timeScale) {}

 /**
  * @returns {boolean}
  */
 isActive() {
   return true;
 }

 /**
  * @returns {Source}
  */
 clone() {}
}

export default Source;
